import type {Module} from "vuex";
import type {LangOverridesTranslations} from "@/global/types/i18n";
import type {RootState} from "@/store/types";
import {delivery} from "@/api/delivery";
import {retryRequest} from "@/helpers/request";

// Banner as returned by GET /banners: message per locale
export interface BannerResponseItem {
    _id: string
    message: Record<string, string>
}

export interface Banner {
    id: string
    message: string
    lang_overrides: LangOverridesTranslations
    _id?: string
}

export interface BannersState {
    hide: string | null
    items: Banner[]
}

const banners: Module<BannersState, RootState> = {
    namespaced: true,
    state: {
        hide: null,
        items: [],
    },
    getters: {
        items: (state): Banner[] => state.items.filter(item => !item._id || item._id != state.hide)
    },
    mutations: {
        setItems: (state, items: Banner[]) => state.items = items,
    },
    actions: {
        fetch: context => retryRequest(() => delivery.get<{results: BannerResponseItem[] | null}>("/banners")).then(
            response => {
                const items: Banner[] = [];

                (response.data.results || []).forEach((item) => items.push({
                    id: item._id,
                    message: item.message["en-US"] ?? "",
                    lang_overrides: Object.keys(item.message).reduce(
                        (result: LangOverridesTranslations, locale) => ({
                            ...result,
                            [locale]: {
                                message: item.message[locale]
                            }
                        }),
                        {}
                    )
                }));

                context.commit("setItems", items)
            }
        ),
        clear: context => context.commit("setItems", [])
    }
}

export default banners
